import { Box, Icon } from '@chakra-ui/react'
import {
  CheckCircle,
  HelpCircle,
  Hourglass,
  LoaderCircle,
  XCircle,
} from 'lucide-react'
import type React from 'react'
import styles from './clusterUpdateTaskStatus.module.css'

export enum ClusterUpdateStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
}

interface ClusterUpdateWorkflowStatusProps {
  status: ClusterUpdateStatus
}

const ClusterUpdateWorkflowStatusIcon: React.FC<
  ClusterUpdateWorkflowStatusProps
> = ({ status }) => {
  function taskStatusIcon() {
    if (status === ClusterUpdateStatus.PENDING) {
      return <Icon as={Hourglass} size="md" color="gray.500" />
    }

    if (status === ClusterUpdateStatus.IN_PROGRESS) {
      return (
        <Icon
          as={LoaderCircle}
          size="md"
          color="blue.500"
          className={styles.rotatingCw}
        />
      )
    }

    if (status === ClusterUpdateStatus.SUCCESS) {
      return <Icon as={CheckCircle} size="md" color="green.600" />
    }

    if (status === ClusterUpdateStatus.FAILED) {
      return <Icon as={XCircle} size="md" color="red.600" />
    }

    // By default
    return <Icon as={HelpCircle} size="md" color="gray.500" />
  }

  return <Box paddingY="0.25rem">{taskStatusIcon()}</Box>
}

export default ClusterUpdateWorkflowStatusIcon
